module.exports = __webpack_public_path__ + "img/open-icon-dark.a3b79d39.svg";